import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Inventory-sourced value. Rendered as a filled box rather than an input,
 * because the analyst cannot edit what the inventory supplied.
 */
@Component({
  selector: 'ui-readonly-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ui-readonly-field.component.html',
})
export class UiReadonlyFieldComponent {
  readonly label = input.required<string>();
  readonly value = input<string>('');
}
